/* eslint-disable no-console */
import axios from 'axios';
import getCookie from '../util/getCookie';

export const getActors = ({ navigationApiUrl, search, limit, offset, headers }) => {
    const url = `${navigationApiUrl}/v1/actors`;
    const params = { search, limit, offset };

    return axios.get(url, { headers, params })
        .then(res => res.data)
        .catch(err => {
            console.log(err);
            return [];
        });
};

export const getScenes = ({ navigationApiUrl, search, limit, offset, type, headers }) => {
    const url = `${navigationApiUrl}/v1/releases`;
    const params = { search, limit, offset, type };

    return axios.get(url, { headers, params })
        .then(res => res.data)
        .catch(err => {
            console.log(err);
            return [];
        });
};

export const getCategories = ({ navigationApiUrl, search, limit, offset, type, headers }) => {
    const url = `${navigationApiUrl}/v1/tags`;
    const params = { search, limit, offset, type };

    return axios.get(url, { headers, params })
        .then(res => res.data)
        .catch(err => {
            console.log(err);
            return [];
        });
};

export const getSearchData = ({ navigationApiUrl, search, limit, offset }) => {
    const { instance_token, access_token_ma } = getCookie(); // eslint-disable-line camelcase

    const headers = {
        Instance: instance_token,
        Authorization: access_token_ma,
    };

    return Promise.all([
        getActors({ navigationApiUrl, search, limit, offset, headers }),
        getScenes({ navigationApiUrl, search, limit, offset, type: 'scene', headers }),
        getCategories({ navigationApiUrl, search, limit, offset, type: 'actor', headers }),
        getCategories({ navigationApiUrl, search, limit, offset, type: 'scene', headers }),
    ]).then(res => ({
        actors: res[0].result,
        releases: res[1].result,
        actorsCategories: res[2].result,
        scenesCategories: res[3].result,
    }));
};
